import { useT } from "@/lib/i18n/use-t";
import type { ImageConfig } from "@/lib/types/flow";
import { T } from "./image-renderer.i18n";

type ImageRendererProps = {
  config: ImageConfig;
};

export function ImageRenderer({ config }: ImageRendererProps) {
  const t = useT(T);
  if (!config.url) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm text-muted-foreground">{t.noImage}</p>
      </div>
    );
  }

  return (
    <div className="w-full overflow-hidden rounded-lg">
      <img
        src={config.url}
        alt={config.alt || ""}
        className="max-w-full max-h-96 h-auto w-auto mx-auto object-contain"
      />
    </div>
  );
}
